module.exports = __webpack_public_path__ + "img/figure-5.135a5c5f.png";